import "./About.css";
import aboutImg from "../assets/AboutUs.png"; // 👈 apni image

export default function About() {
  return (
    <div className="about-container">

     <h1 className="about-heading">हमारे बारे में</h1>

      {/* 🔥 IMAGE + TEXT */}
      <div className="about-top">
        <div className="about-image">
          <img src={aboutImg} alt="पश्चिमांचल" />
        </div>

        <div className="about-text">
          <p>
            हम पश्चिमांचल एक सामाजिक पहल है, जिसका उद्देश्य पश्चिम उत्तर प्रदेश के युवाओं को एक मंच पर जोड़ना है।
            हमारा लक्ष्य जागरूकता बढ़ाना, एकता को मजबूत करना और क्षेत्र के विकास के लिए एक सशक्त नेटवर्क तैयार करना है।
          </p>

          <p>
            यह प्लेटफॉर्म उन लोगों के लिए है जो अपने क्षेत्र के लिए कुछ सकारात्मक करना चाहते हैं
            और समाज में बदलाव लाने की इच्छा रखते हैं।
          </p>
        </div>        

      </div>

      {/* 🔥 SECTION */}
      <div className="about-section">

        <div className="about-box">
          <h3>हमारा दृष्टिकोण</h3>
          <p>
            एक सशक्त और विकसित पश्चिमांचल, जहाँ युवा सशक्त हों और हर व्यक्ति को बेहतर अवसर मिल सकें।
          </p>
        </div>

        <div className="about-box">
          <h3>हमारा लक्ष्य</h3>
          <p>
            युवाओं को एक ऐसा मंच प्रदान करना जहाँ वे अपनी आवाज उठा सकें
            और क्षेत्र के विकास में सक्रिय रूप से योगदान दे सकें।
          </p>
        </div>

        <div className="about-box">
          <h3>हमारी कार्यशैली</h3>
          <p>
            जागरूकता, एकता और सक्रिय प्रयासों के माध्यम से हम एक मजबूत समुदाय का निर्माण करना चाहते हैं।
          </p>
        </div>

      </div>

      {/* 🔥 TAGLINE */}
      <div className="tagline">
        <p>
          “पहला प्रयास — पश्चिमांचल का विकास <br/>
          अंतिम विकल्प — अलग राज्य”
        </p>
      </div>
        <p style={{ marginTop: "10px", fontStyle: "italic", textAlign:"center" }}>
         “हम मिलकर बदलाव ला सकते हैं”
        </p>

    </div>
  );
}